import Icon from '../../../components/AppIcon';
import type { ConsultationMetric } from '../types';

interface MetricCardProps {
  metric: ConsultationMetric;
}

const MetricCard = ({ metric }: MetricCardProps) => {
  const isPositive = metric.change >= 0;
  
  return (
    <div className="bg-card rounded-lg border border-border p-6 hover:shadow-lg transition-shadow duration-200">
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <p className="text-sm font-medium text-muted-foreground mb-1">
            {metric.label}
          </p>
          <p className="text-3xl font-semibold text-foreground mb-2">
            {metric.value}
          </p>
          <div className="flex items-center gap-1">
            <Icon 
              name={isPositive ? 'TrendingUp' : 'TrendingDown'} 
              size={16} 
              color={isPositive ? 'var(--color-success)' : 'var(--color-error)'} 
            />
            <span 
              className={`text-sm font-medium ${
                isPositive ? 'text-success' : 'text-error'
              }`}
            >
              {isPositive ? '+' : ''}{metric.change}%
            </span>
            <span className="text-sm text-muted-foreground ml-1">
              {metric.changeLabel}
            </span>
          </div>
        </div>
        <div 
          className="w-12 h-12 rounded-lg flex items-center justify-center"
          style={{ backgroundColor: `${metric.color}15` }}
        >
          <Icon name={metric.icon} size={24} color={metric.color} />
        </div>
      </div>
    </div>
  );
};

export default MetricCard;